/**
 * @author       kevin.chau@zumper.com (Kevin Chau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackCallEvent.js
 */

import { AnalyticsC, trackGAEvent } from '@zcode/nr-utils'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'

export const trackCallEvent = ({
  feedName,
  isMonetizedM3,
  isMonetizedM4,
  providerId,
}: Listable | MaybeEmptyProperty = {}) => {
  if (isMonetizedM3) {
    trackGAEvent(AnalyticsC.CALLS, AnalyticsC.CALL_M3)
  } else if (isMonetizedM4) {
    trackGAEvent(AnalyticsC.CALLS, AnalyticsC.CALL_M4)
  } else {
    trackGAEvent(AnalyticsC.CALLS, AnalyticsC.CALL)
  }

  if (feedName === 'listhub' && providerId) {
    window.listhubTrack?.('AGENT_PHONE_CLICKED', providerId)
  }
}
